import {
  ClientIntegrationType,
  useListClientIntegrationsQuery,
} from "~/operations";
import { useScope } from "~/hooks/useScope";
import { useCanCreate } from "~/lib/iam/actions/mondoo/integrations/IntegrationsManager/Create";

export function useSecurityPipelineIntegrations() {
  const { activeScope } = useScope();

  const {
    data: securityPipelineIntegrationsData,
    loading: securityPipelineIntegrationsLoading,
    error: securityPipelineIntegrationsError,
  } = useListClientIntegrationsQuery({
    variables: {
      input: {
        spaceMrn: activeScope?.mrn || "",
        filterQuery: {
          types: [ClientIntegrationType.SecurityPipelineGithub],
        },
      },
    },
    skip: !activeScope,
    fetchPolicy: "network-only",
  });

  const integrations =
    securityPipelineIntegrationsData?.listClientIntegrations.integrations || [];
  const hasSecurityPipelineIntegrations = integrations.length > 0;
  const integration = integrations.at(0);
  const hasError = !!securityPipelineIntegrationsError;
  const hasPermission = useCanCreate(activeScope);
  const canCreateIntegration =
    !hasError && hasPermission && !hasSecurityPipelineIntegrations;

  return {
    isLoading: securityPipelineIntegrationsLoading,
    hasError: securityPipelineIntegrationsError,
    hasSecurityPipelineIntegrations,
    integration,
    integrations,
    canCreateIntegration,
  };
}
